const setRequest = ({ commit, getters, dispatch }, payload) => {
  if (!getters.isCalling && payload.call !== null) {
    dispatch(
      'setTimer',
      setTimeout(() => {
        dispatch('setDelay', true)
      }, 500)
    )
  }
  commit('SET_REQUEST', { ...payload, getters })
}

const setDelay = ({ commit }, delay) => {
  commit('SET_DELAY', delay)
}

const setTimer = ({ commit }, timerId) => {
  commit('SET_TIMER', timerId)
}

const clearAllRequest = ({ commit, getters, dispatch, state }, payload) => {
  for (let key in state) {
    if (key !== 'isDelayed' && key !== 'timerId' && key !== 'getProductListOfCart' && state[key] !== null) { // 카트 목록은 무조건 받아야한다.
      commit('SET_REQUEST', { apiName: key, call: null , getters })
    }
  }
}

export default {
  setDelay,
  setRequest,
  setTimer,
  clearAllRequest
}
